import { useState, useCallback, useContext, useEffect } from 'react'
import { registerGuest } from 'services/auth'
import {
  getUserType,
  userContext,
} from 'global/context/sub-contexts/userContext'
import { userTypeEnum } from 'services/user'

export const useUserAuth = isEmbed => {
  const { askToLogin, setProfile, unauthorized } = useContext(userContext)
  const [userType, setUserType] = useState(() => getUserType())

  // Mirrors initUser() from the class component: handle guest auto-registration
  // for embeds and unauthorized state for non-registered non-embed users
  useEffect(() => {
    const currentType = getUserType()

    if (currentType !== userTypeEnum.REGISTERED) {
      if (isEmbed) {
        if (currentType === userTypeEnum.NONE) {
          registerGuest()
            .then(response => {
              setUserType(userTypeEnum.GUEST)
              setProfile(response.detail.user)
            })
            .catch(e => console.warn('embed register', e))
        }
      } else {
        unauthorized()
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const refreshUserType = useCallback(() => {
    const updated = getUserType()
    setUserType(updated)
    return updated
  }, [])

  const handleAuthRequired = useCallback(async () => {
    if (isEmbed) {
      try {
        const response = await registerGuest()
        setProfile(response.detail.user)
      } catch (e) {
        console.warn('handleGuest', e)
      }
    } else {
      const current = refreshUserType()
      if (current !== userTypeEnum.REGISTERED) {
        askToLogin()
      }
    }
  }, [isEmbed, setProfile, askToLogin, refreshUserType])

  const handleAttemptStepStart = useCallback(
    async _stepId => {
      const current = refreshUserType()

      if (isEmbed === false && current !== userTypeEnum.REGISTERED) {
        askToLogin()
        return false
      }

      if (isEmbed === true && current === userTypeEnum.NONE) {
        try {
          const response = await registerGuest()
          setUserType(userTypeEnum.GUEST)
          setProfile(response.detail.user)
          return true
        } catch (e) {
          console.warn('embed register', e)
          return false
        }
      }

      return true
    },
    [isEmbed, askToLogin, setProfile, refreshUserType],
  )

  return { userType, refreshUserType, handleAuthRequired, handleAttemptStepStart }
}
